import { SxProps, Theme } from '@mui/material'

export const submitButtonIconSx: SxProps<Theme> = {
  width: '2.4rem',
  height: '2.4rem',
}

export const loadingButtonSx: SxProps<Theme> = {
  lineHeight: '1.6rem',
  alignSelf: { xs: 'stretch', md: 'flex-end' },
  '&.Mui-disabled': {
    backgroundColor: (theme) => theme.palette.background.default,
  },
}

export const inputSx: SxProps<Theme> = {
  letterSpacing: '0.015rem',
  background: (theme) => theme.palette.background.paper,
  borderRadius: '0.4rem 0.4rem 0rem 0rem',
}

export const textSx: SxProps<Theme> = {
  color: (theme) => theme.palette.primary.contrastText,
  textAlign: {
    xs: 'center',
    md: 'left',
  },
}

export const leadMagnetWrapperSx: SxProps<Theme> = {
  padding: {
    xs: '2.4rem',
    md: '4.8rem',
  },
  background: 'linear-gradient(180deg, #184A9B 0%, #03378B 100%)',
  borderTop: '0.1rem solid rgba(255, 255, 255, 0.30)',
  borderRadius: 0,
  justifyContent: 'center',
  alignItems: 'center',
  display: 'flex',
}

export const bookImageWrapperSx: SxProps<Theme> = {
  display: 'flex',
  gap: {
    xs: '1.6rem',
    md: '3.2rem',
  },
  alignItems: 'center',
  flexDirection: {
    xs: 'column',
    md: 'row',
  },
}

export const bookImageSx: SxProps<Theme> = {
  width: {
    xs: '12rem',
    md: '22rem',
  },
  height: {
    xs: '15.27rem',
    md: '28rem',
  },
}

export const textWrapperSx: SxProps<Theme> = {
  width: '100%',
  gap: '1.6rem',
  display: 'flex',
  flexDirection: 'column',
  alignItems: {
    xs: 'center',
    md: 'start',
  },
}

export const formContainerSx: SxProps<Theme> = {
  display: 'flex',
  rowGap: '1.6rem',
  columnGap: '1.2rem',
  width: '100%',
  '& .MuiFormHelperText-root': {
    color: (theme) => theme.palette.primary.contrastText,
  },
}

export const fieldsWrapperSx: SxProps<Theme> = {
  display: 'flex',
  flexDirection: {
    xs: 'column',
    md: 'row',
  },
  width: '100%',
  gap: {
    xs: '1.6rem',
    md: '1.2rem',
  },
}
